import React from 'react'
import UiRangeSlider from "../../../components/form/UiRangeSlider"
import {
    UiFilterWr,
    UiFilterTitle,
    UiFilterSeeMore,
    UiFilterContainer
} from "../../../components/common/UiFilterComponents"
import UiFiterInput from "../../../components/form/UiFilterInput"
import { UiCheckboxInput } from "../../../components/form/UiInput"


export default function LoyaltyStoreFilter(props) {

    return (
        <>
        
            <UiFilterWr>
                <UiFilterTitle title="Filter" />
                <UiFiterInput placeholder="Search Keywords" />
            </UiFilterWr>
            <UiFilterWr>
                <UiFilterTitle title="Popular Filters" />
                <UiCheckboxInput label="Experience" />
                <UiCheckboxInput label="Experience" />
                <UiCheckboxInput label="Experience" />
                <UiCheckboxInput label="Experience" />
                <UiFilterSeeMore />
            </UiFilterWr>
            <hr />
            <UiFilterWr>
                <UiFilterTitle title="Range" />
                <UiRangeSlider min={50} max={15000} />
            </UiFilterWr>
            <hr />
            <UiFilterWr>
                <UiFilterTitle title="Loyalty Type" />
                <UiCheckboxInput label="Loyalty" />
                <UiCheckboxInput label="Loyalty" />
                <UiCheckboxInput label="Loyalty" />
                
            </UiFilterWr>
            <hr />
            <UiFilterWr>
                <UiFilterTitle title="Loyalty" />
                <UiCheckboxInput label="Loyalty" />
                <UiCheckboxInput label="Loyalty" />
                <UiCheckboxInput label="Loyalty" />
                <UiCheckboxInput label="Loyalty" />
                <UiCheckboxInput label="Loyalty" />
                <UiFilterSeeMore />
            </UiFilterWr>
            <hr />
          
       

        </>
    )
}
